import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import AlertsGroup from "client_config/AlertsGroup";
import ManageSubsByClient from "alert_subscriptions/ManageSubsByClient";
import OnboardingAlertsGroup from "onboarding/AlertsGroup";

const addUser = (email, sectionName, sectionId) => {
  let returnedData = "";
  if (email && email != "" && sectionId && sectionId != "") {
    $.ajax({
      type: "POST",
      url: "/datapulse/alerts/subscribe-user/",
      async: false,
      data: {
        email: email,
        section_name: sectionName,
        section_id: sectionId,
      },
      success: (data) => {
        returnedData = data;
      },
    });
  }
  return returnedData;
};

const removeUser = (email, sectionName, sectionId) => {
  let removalSuccessful = false;
  if (email && email != "" && sectionId && sectionId != "") {
    $.ajax({
      type: "POST",
      url: "/datapulse/alerts/unsubscribe-user/",
      async: false,
      data: {
        email: email,
        section_name: sectionName,
        section_id: sectionId,
      },
      success: () => {
        removalSuccessful = true;
      },
    });
  }
  return removalSuccessful;
};

export default function Alerts(props) {
  const platforms = [
    {
      platformName: "Google Ads",
      alerts: [
        {
          name: "google_ads_display_impressions_emergency_detector",
          title: "Impressions emergency detector",
          desc: "Gets the number of Google Ads impressions on display campaigns for each account and if it falls beneath a certain threshold, emails all DP employees.",
        },

        {
          name: "google_ads_display_disapproved_ads_detector",
          title: "Disapproved ads detector",
          desc: "Creates an alert with a list of all disapproved display ads on Google Ads.",
        },
        {
          name: "google_ads_display_out_of_stock_detector",
          title: "Out of stock detector",
          desc: "Checks the landing pages of all display ads on accounts for specific 'out of stock' related language and creates a list of landing pages that match.",
        },
        {
          name: "google_ads_display_impressions_flux_detector",
          title: "Impressions flux detector",
          desc: "Creates an alert if Google Ads display impressions fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
        {
          name: "google_ads_display_clicks_flux_detector",
          title: "Clicks flux detector",
          desc: "Creates an alert if Google Ads display clicks fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
        {
          name: "google_ads_display_url_issue_detector",
          title: "URL issue detector",
          desc: "Goes through all Google Ads display ads in an account and makes an alert of pages that produce unacceptable response codes.",
        },

        {
          name: "google_ads_display_spend_flux_detector",
          title: "Spend flux detector",
          desc: "Creates an alert if Google Ads display spend fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },

        {
          name: "google_ads_display_conversions_flux_detector",
          title: "Conversions flux detector",
          desc: "Creates an alert if Google Ads display conversions fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
        {
          name: "google_ads_display_conversion_rate_flux_detector",
          title: "Conversion Rate flux detector",
          desc: "Creates an alert if Google Ads display conversion rate fall below or rise above a custom threshold",
          options: [
            {
              name: "min_threshold",
              title: "Min threshold:",
              placeholder: "Default 15%",
            },
            {
              name: "max_threshold",
              title: "Max threshold:",
              placeholder: "Default 300%",
            },
          ],
        },
      ],
    },
  ];

  return (
    <>
      <Container style={{ backgroundColor: props.onboarding ? "#f5f5f5" : undefined }} fluid className="p-3">
        <Row>
          <Col>
            <div className="pt-4 pb-2">
              <p className="text-info f18 visby-bold">Alerts:</p>
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="pr-0 pr-md-5 pl-0 pl-md-4" xl={8}>
            <div className="pb-4 px-3">
              {platforms.map((platform) => {
                return props.onboarding ? (
                  <OnboardingAlertsGroup
                    key={platform.platformName}
                    platform={platform}
                    service="display"
                    scripts={props.displayScripts}
                    scriptVariables={props.displayScriptsVar}
                    setScripts={props.setDisplayScripts}
                    setScriptsVar={props.setDisplayScriptsVar}
                    onboarding
                  />
                ) : (
                  <AlertsGroup
                    key={platform.platformName}
                    platform={platform}
                    service="display"
                    scripts={props.display_section.scripts}
                    scriptVariables={props.display_section.script_variables}
                  />
                );
              })}
            </div>
          </Col>
          <Col xl={4}>
            <div
              className="subs-by-client pt-4 mb-4 px-3"
              style={{
                backgroundColor: "#e1e1e1",
                paddingBottom: "150px"
              }}>
              <h5>Subscribed to these alerts:</h5>
              <ManageSubsByClient
                users={props.users}
                addUser={addUser}
                removeUser={removeUser}
                subscribed_users={props.subs.display_subs}
                section_id={props.subs.display_section_id}
                section_name="DisplaySection"
                client_name={props.company_name}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}
